import React, { useState } from 'react';
import { Sun, Gift, Sparkles, Wallet, CalendarDays, ArrowRight } from 'lucide-react';
import BookingCalendar from './BookingCalendar';

const DEALS = [
  { key: 'lunchtime', icon: Sun, label: 'Lunchtime 10% off', detail: 'Mon–Fri 12–3pm' },
  { key: 'firstvisit', icon: Gift, label: 'First visit 5% off', detail: 'automatic' },
  { key: 'thursday', icon: CalendarDays, label: 'Thursdays 5% off', detail: 'Buggie, Eegi & Lana' },
  { key: 'deposit', icon: Wallet, label: 'Deposit 5% off', detail: 'pay deposit online' },
  { key: 'tryrino', icon: Sparkles, label: 'TRYRINO 5% off', detail: 'new clients with Rino' },
];

const getDublinNow = () => new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Dublin' }));

export const getDealStatus = (key, now = getDublinNow()) => {
  const preview = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('deals_preview');
  const day = now.getDay();
  const mins = now.getHours() * 60 + now.getMinutes();
  if (key === 'lunchtime') {
    if (preview === 'lunchtime') return 'live';
    if (day >= 1 && day <= 5 && mins >= 720 && mins < 900) return 'live';
    if (day >= 1 && day <= 5 && mins < 720) return 'today';
  }
  if (key === 'thursday') {
    if (preview === 'thursday') return 'live';
    if (day === 4 && mins >= 540 && mins < 1080) return 'live';
    if (day === 4) return 'today';
  }
  return null;
};

const STATUS_RANK = { live: 0, today: 1 };

const DealsStrip = () => {
  const [bookingOpen, setBookingOpen] = useState(false);
  const deals = DEALS.map((d) => ({ ...d, status: getDealStatus(d.key) })).sort(
    (a, b) => (STATUS_RANK[a.status] ?? 2) - (STATUS_RANK[b.status] ?? 2)
  );

  return (
    <>
      <div className="bg-luxury-green-900 border-y border-luxury-gold/25" data-testid="deals-strip">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-3 flex items-center gap-3 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <span className="text-luxury-gold text-[10px] uppercase tracking-[0.25em] font-semibold flex-shrink-0">
            Today's Deals
          </span>
          {deals.map((d) => (
            <span
              key={d.key}
              className={`flex items-center gap-2 rounded-full px-4 py-1.5 flex-shrink-0 border transition-colors ${
                d.status === 'live'
                  ? 'bg-luxury-gold border-luxury-gold text-luxury-green-900'
                  : d.status === 'today'
                    ? 'bg-luxury-green-800 border-luxury-gold/70'
                    : 'bg-luxury-green-800 border-luxury-gold/20'
              }`}
              data-testid={`deal-pill-${d.key}`}
            >
              {d.status === 'live' && (
                <span className="flex items-center gap-1 flex-shrink-0" data-testid={`deal-live-${d.key}`}>
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-luxury-green-700 opacity-60" />
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-luxury-green-800" />
                  </span>
                  <span className="text-[9px] font-bold uppercase tracking-wider">Live now</span>
                </span>
              )}
              {d.status === 'today' && (
                <span className="text-[9px] font-bold uppercase tracking-wider text-luxury-gold flex-shrink-0" data-testid={`deal-today-${d.key}`}>
                  Today
                </span>
              )}
              <d.icon size={13} className={`flex-shrink-0 ${d.status === 'live' ? 'text-luxury-green-800' : 'text-luxury-gold'}`} />
              <span className={`text-xs font-medium whitespace-nowrap ${d.status === 'live' ? 'text-luxury-green-900' : 'text-alabaster-100'}`}>
                {d.label}
              </span>
              <span className={`text-[10px] whitespace-nowrap hidden sm:inline ${d.status === 'live' ? 'text-luxury-green-800/80' : 'text-alabaster-300/70'}`}>
                {d.detail}
              </span>
            </span>
          ))}
          <button
            onClick={() => setBookingOpen(true)}
            className="ml-auto flex items-center gap-1.5 bg-luxury-gold hover:bg-luxury-gold-600 text-luxury-green-900 rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-wider transition-colors flex-shrink-0"
            data-testid="deals-strip-book-btn"
          >
            Book Now
            <ArrowRight size={12} />
          </button>
        </div>
      </div>

      <BookingCalendar isOpen={bookingOpen} onClose={() => setBookingOpen(false)} />
    </>
  );
};

export default DealsStrip;
